const state = {
    screenshotList: [],
    transferEquipmentList: [],
    authorizeObj: {},
    // activationCodeList: []
    // 全局分组列表
    globalAllGroupList: [],
    proxyEquipmentList: [],
    globalProxyIpForm: [],

}
const mutations = {
    SET_SCREENSHOTLIST: (state, arr) => {
        state.screenshotList = arr
    },
    SET_TEANSFEREQUIPMENTLIST: (state, cover) => {
        state.transferEquipmentList = cover
    },
    SET_AUTHORIZEOBJ: (state, cover) => {
        state.authorizeObj = cover
    },
    SET_GLOBALALLGROUPLIST: (state, cover) => {
        state.globalAllGroupList = cover
    },
    // SET_ACTIVATIONCODELIST: (state, cover) => {
    //     state.activationCodeList = cover
    // },
    SET_PROXYEQUIPMENTLIST: (state, cover) => {
        state.proxyEquipmentList = cover
    },
    SET_GLOBALPROXYIPFORM: (state, cover) => {
        state.globalProxyIpForm = cover
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}